
import { useEffect, useRef, useState } from 'react';
import AnimatedText from '../../../components/base/AnimatedText';
import ParallaxSection from '../../../components/base/ParallaxSection';

const services = [
  {
    icon: 'ri-vip-crown-line',
    title: 'VIPフロア',
    description: '7階VIPフロアで特別なひとときをお過ごしください',
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/a743858f0c7fa7a769f5786e77547b19.jfif'
  },
  {
    icon: 'ri-home-4-line',
    title: 'メインフロア',
    description: '6階メインフロアでリラックスした時間をお楽しみください',
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/d42116c4681277459b7cfb3c5c9cd558.jfif'
  },
  {
    icon: 'ri-user-star-line',
    title: '実力派キャスト',
    description: '豪華な店内と実力派揃いのキャストがお出迎え',
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/40f215424a7903e117f051138773fd3f.jfif'
  },
  {
    icon: 'ri-building-line',
    title: '2フロア展開',
    description: '神戸初！2フロア展開のラグジュアリーなホストクラブ',
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/d9c4bdd2f4762da3383c42e870240a73.jfif'
  }
];

export default function ServicesSection() {
  const [visibleCards, setVisibleCards] = useState<number[]>([]);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observers = cardRefs.current.map((ref, index) => {
      if (!ref) return null;
      
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setVisibleCards(prev => [...prev, index]);
            }, index * 200);
          }
        },
        { threshold: 0.1 }
      );
      
      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach(observer => observer?.disconnect());
    };
  }, []);

  return (
    <section id="services" className="py-20 pb-32 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="サービス"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="最高級のおもてなしで特別な時間をお約束いたします"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <ParallaxSection key={index} speed={0.1}>
              <div
                ref={el => cardRefs.current[index] = el}
                className={`bg-black/50 backdrop-blur-sm rounded-lg overflow-hidden transform transition-all duration-700 hover:scale-105 cursor-pointer ${
                  visibleCards.includes(index) 
                    ? 'opacity-100 translate-y-0' 
                    : 'opacity-0 translate-y-8'
                }`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className={`${service.icon} text-white text-xl`}></i>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">{service.description}</p>
                </div>
              </div>
            </ParallaxSection>
          ))}
        </div>
      </div>
    </section>
  );
}
